import { render, staticRenderFns } from "./MetricsPage.vue?vue&type=template&id=da88f996&scoped=true"
import script from "./MetricsPage.vue?vue&type=script&lang=js"
export * from "./MetricsPage.vue?vue&type=script&lang=js"
import style0 from "./MetricsPage.vue?vue&type=style&index=0&id=da88f996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da88f996",
  null
  
)

export default component.exports